export default "__VITE_ASSET__DktdxJaE__"